import React, { useEffect } from 'react';
import { ChatInbox } from '../shared/ChatInbox';
import { useChatStore } from '../../store/chatStore';

export const ClientMessages: React.FC = () => {
  const { conversations, conversationsLoading, loadConversations, conversationsError } = useChatStore();

  useEffect(() => {
    loadConversations();
  }, [loadConversations]);

  if (conversationsLoading && conversations.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#636E72' }}>
        Loading messages...
      </div>
    );
  }

  if (conversationsError) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#E17055' }}>
        {conversationsError}
      </div>
    );
  }

  return (
    <ChatInbox
      conversations={conversations}
      basePath="/client"
      title="Messages"
      subtitle="Your survey chats and support conversations"
    />
  );
};
